import { observable } from "mobx";
import merge from "lodash/merge";
import { Expose } from "class-transformer";
import type { EntityValidationRules } from "services/validation/entityValidationRules";

export default class ReqChangeInvoiceFormat {
  @observable
  invoice_short_format!: boolean;

  @observable
  @Expose({ name: "supply_point_ids" })
  supplyPointIds!: number[];

  static ValidationRules = {
    invoice_short_format: { required: true },
    supplyPointIds: { required: true },
  };
}

merge(ReqChangeInvoiceFormat.ValidationRules, {
  supplyPointIds: { required: true },
  invoice_short_format: { required: true },
} as EntityValidationRules<ReqChangeInvoiceFormat>);
